document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    var stickyBanner = document.querySelector('.sticky-banner');
    var mainFooter = document.querySelector('.main-footer');

    // Add spacing to the footer if a sticky banner is enabled.
    if (stickyBanner && mainFooter && window.innerWidth >= 576) {
        mainFooter.style.marginBottom = stickyBanner.offsetHeight + 'px';
    }
});